import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  margin-top: 104px;

  width: 100%;
  height: calc(100% - 104px);

  overflow: auto;

  padding-bottom: 24px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 24px;
`;

export const ContainerContent = styled.div`
  width: fit-content;
  margin: auto;
  padding-top: 24px;

  gap: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const NavBarContainer = styled.div`
  > div {
    left: 0px;
    width: 100%;
    z-index: 5;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: end;
  gap: 16px;
`;
